import { render } from "./SubTaskEdit.vue?vue&type=template&id=001c45b9&scoped=true&ts=true"
import script from "./SubTaskEdit.vue?vue&type=script&lang=ts"
export * from "./SubTaskEdit.vue?vue&type=script&lang=ts"

import "./SubTaskEdit.vue?vue&type=style&index=0&id=001c45b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001c45b9"]])

export default __exports__